export const JWT_LOCAL_STORAGE_KEY = 'JWT_LOCAL_STORAGE_KEY';
